import { ReactElement, ReactNode, useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { FormikProps } from 'formik';
import { styles } from './auth-layout.styles';

interface IAuthTextFieldProps {
  name: string;
  label: string;
  formik: FormikProps<any>;
  type?: string;
  autoComplete?: string;
  icon: ReactNode;
  disabled?: boolean;
}

const AuthTextField = ({
  name,
  label,
  formik,
  type = 'text',
  autoComplete,
  icon,
  disabled,
}: IAuthTextFieldProps): ReactElement => {
  const [visible, setVisible] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && visible ? 'text' : type;
  const showError = Boolean(formik.touched[name] && formik.errors[name]);
  const errorId = `${name}-error`;
  const fieldValue = formik.values[name];

  return (
    <TextField
      sx={styles.field}
      fullWidth
      id={name}
      name={name}
      label={label}
      type={inputType}
      autoComplete={autoComplete}
      value={typeof fieldValue === 'string' ? fieldValue : ''}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={showError}
      helperText={showError ? String(formik.errors[name] ?? '') : ' '}
      disabled={disabled}
      required
      inputProps={{
        'aria-invalid': showError,
        'aria-describedby': showError ? errorId : undefined,
      }}
      FormHelperTextProps={{ id: errorId }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <span style={{ display: 'flex' }}>{icon}</span>
          </InputAdornment>
        ),
        endAdornment: isPassword ? (
          <InputAdornment position="end">
            <IconButton
              sx={styles.iconButton}
              aria-label={visible ? 'Hide password' : 'Show password'}
              onClick={() => setVisible((current) => !current)}
              edge="end"
              size="small"
            >
              {visible ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};

export default AuthTextField;
